import { Grid } from '@mui/material'
import { memo, useMemo } from 'react'
import DewiCardGrid from '@components/DewiCardGrid'
import { useTranslation } from 'react-i18next'
import SkeletonCard from '@components/DewiCard/SkeletonCard'
import TokenCard from '@components/TokenCard'
import { TokenAccount, useTokens } from '@hooks/useTokens'
import DabbaTokenCard from '@components/DabbaTokenCard'

const SYMBOL_BLACKLIST = ['FUCKCATS']

function TokenCardList() {
  const { t } = useTranslation()
  const { tokenAccounts, loading, error } = useTokens()

  const filteredTokenAccounts = useMemo(() => {
    // Copy before sorting: the array belongs to the provider.
    const sortedByBalance = [...(tokenAccounts || [])]
      .filter((t) => !SYMBOL_BLACKLIST.includes(t.symbol))
      .sort((a, b) => Number(b.balance) - Number(a.balance))

    // Make sure that you order it with FOUNDERS first, HNT second, MOBILE third, IOT fourth, Dabba fifth, and the rest last
    const ordered = [...sortedByBalance].sort((a, b) => {
      if (a.symbol === 'FOUNDERS') return -1
      if (b.symbol === 'FOUNDERS') return 1
      if (a.symbol === 'HNT') return -1
      if (a.symbol === 'MOBILE') return -1
      if (a.symbol === 'IOT') return -1
      if (a.symbol === 'HONEY') return -1
      return 1
    })

    // add an empty token account for dabba after MOBILE
    const dabbaIndex = ordered.findIndex((t) => t.symbol === 'MOBILE')
    const dabba: TokenAccount = {
      symbol: 'DABBA',
      mint: 'DABBA',
      tokenAccount: 'DABBA',
      balance: '0',
      image: '',
      decimals: 0,
      name: '',
      price: null,
      program: 'spl',
    }
    ordered.splice(dabbaIndex + 1, 0, dabba)

    return ordered
  }, [tokenAccounts])

  if (loading) {
    // create array of 20 empty items
    return (
      <DewiCardGrid>
        {Array.from(Array(40).keys()).map((i) => (
          <Grid key={i} item xs={5} sm={5} md={2.8} lg={2.8} xl={1.8}>
            <SkeletonCard variant="rectangular" />
          </Grid>
        ))}
      </DewiCardGrid>
    )
  }

  if (error) {
    return (
      <p className="text-gray-5 text-size-2 font-space px-6 py-8">
        {t('generic.error.message')}
      </p>
    )
  }

  return (
    <DewiCardGrid>
      {filteredTokenAccounts
        .filter((t) => !!t.symbol)
        .map((token) => (
          <Grid
            key={token.tokenAccount}
            item
            xs={5}
            sm={5}
            md={2.8}
            lg={2.8}
            xl={1.8}
            marginTop={4}
          >
            {token.symbol === 'DABBA' ? (
              <DabbaTokenCard />
            ) : (
              <TokenCard
                mint={token.mint}
                ata={token.tokenAccount}
                balance={token.balance}
                decimals={token.decimals}
                image={token.image}
                symbol={token.symbol}
                name={token.name}
              />
            )}
          </Grid>
        ))}
    </DewiCardGrid>
  )
}

export default memo(TokenCardList)
